<template>
<!-- 分级类目页面 -->
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>